var exports = {
  "lV": "ActionList_LinkItem__dRO31O",
  "FC": "CustomItem__YsmhCE",
  "j8": "PrLink__bfHlUp",
  "Jc": "LeadingVisual__xq-xbY",
  "cn": "PrContent__CR0kHV",
  "v0": "PrTitle__CwFwGo",
  "Bd": "PrRepo__1yqjpg",
  "Cb": "ReleaseLink__7cn6kE",
  "tD": "ReleaseIcon__RVwhj9",
  "ms": "ReleaseIconLatest__krcCSF",
  "st": "ReleaseIconDefault__uZkviw",
  "xG": "ReleaseTagName__c1jVmL",
};

module.exports = exports;
